<ng-container *ngIf="portalLead$ | async">
  <stepper
    [step]="Steps.TravelerDetails"
    [isChangeMode]="portalOrder.isChange"
    [tiers]="portalTiers"
  />

  <div class="my-4 my-md-6 d-flex flex-column flex-md-row">
    <div class="flex-1">
      <h2 class="semi-bold mb-4 mx-4 mx-md-0">Travelers</h2>

      <passengers-form
        (valueChange)="valueChange()"
        (formSubmit)="formSubmit($event)"
        (back)="tryBack()"
        [model]="model"
        [passengersLabels]="passengersLabels"
        [passengers]="passengers"
        [errors]="errors"
      >
        <div class="d-md-none mt-4 mb-4 p-4">
          <ng-container *ngTemplateOutlet="summaryBlock" />
        </div>
      </passengers-form>
    </div>

    <div class="d-none d-md-block ml-md-4 checkout-summary">
      <ng-container *ngTemplateOutlet="summaryBlock" />
    </div>
  </div>
</ng-container>

<ng-template #confirmTemplate>
  <go-back-confirm (back)="back()" />
</ng-template>

<ng-template #summaryBlock>
  <price-summary
    [option]="portalOrder"
    [tier]="state.tier"
    [disruptionProtection]="state.disruptionProtection"
    [tipsAmount]="state.tipsAmount"
    [cancelForAnyReason]="state.cancelForAnyReason"
    [promocodeDiscountAmount]="state.promocodeDiscountAmount"
    [bundle]="state.bundle"
    [actions]="summaryActions"
    (actionClick)="onSummaryAction($event)"
  />
</ng-template>
